import { createSelector } from '@reduxjs/toolkit';
const getAgencies = (state) => state.agencies.data || [];
const getLoading = (state) => state.agencies.loading;
const getError = (state) => state.agencies.error;
const getDefaultAgency = () => ({
    title: 'N/A',
    acronym: 'N/A',
    backgroundColor: '#e0e0e0',
    textColor: '#424242',
});
const makeAgenciesAbbr = createSelector(getAgencies, (agencies) => {
    if (!Array.isArray(agencies))
        return {};
    return agencies.reduce((acc, curr) => {
        const key = typeof curr?.acronym === 'string' && curr.acronym.trim();
        if (key) {
            acc[key] = { ...curr };
        }
        return acc;
    }, {});
});
export const AgenciesSelectors = {
    getAgencies,
    getLoading,
    getError,
    getDefaultAgency,
    makeAgenciesAbbr,
};
